var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');

var ActiveSessionsModal = Marionette.View.extend({
    template: require('../../templates/system/active-sessions-modal.html'),

    ui: {
        modal: '#active-sessions-modal',
        content: '#active-sessions-content',
        loader: '#active-sessions-loader',

        refresh: "#refresh-active-sessions"
    },

    events: {
        'click @ui.refresh': "refresh"
    },

    templateContext: function () {
        return {}
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.mySessionId = options.mySessionId;
    },

    onRender: function () {
        var that = this;
        that.show();
        that.refresh();
    },

    renderTable: function (data) {
        var that = this;

        var tableStart = "<table class='table table-bordered table-hover'><tr><th>Session Id</th><th>Login</th><th>Person</th><th>Is Admin?</th></tr>";
        var tableEnd = "</table>";

        var tableBody = data.map(function (item) {
            return '<tr ' + (that.mySessionId == item.sessionId ? 'style="background-color: yellow;"' : "") + '><td>' + item.sessionId + '</td><td>' + item.login + '</td><td>' + item.person + '</td><td>' + item.isAdmin + '</td></tr>';
        }).join("")

        that.ui.content.html(tableStart + tableBody + tableEnd);
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    refresh: function () {
        var that = this;

        that.utils.showSpinner(that.ui.loader.id);

        $.ajax({
            type: "GET",
            url: '/api/system/sessions',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner(that.ui.loader.id);

                    var transformed = response.filter(function (item) {
                        return item.name != "undefined" && item.name != "null";
                    }).map(function (item) {
                        return {
                            sessionId: item.id,
                            login: item.name,
                            person: that.utils.formatPerson(item.person || {}),
                            isAdmin: ((item.systemRoles || []).indexOf('ADMIN') > -1) ? "YES" : "NO"
                        }
                    });
                    that.data = transformed;
                    that.renderTable(transformed);
                },
                401: function (e) {
                    that.utils.hideSpinner(that.ui.loader.id);
                    that.hide();
                    actionsChannel.request("redirect:to:login");
                }
            },
            error: function (e) {
                console.log(e);
                that.utils.hideSpinner(that.ui.loader.id);
                //notificationsChannel.request('show:notification', e.responseJSON);
            }
        })
    }
});

module.exports = ActiveSessionsModal;


//////////////////
// WEBPACK FOOTER
// ./app/views/system/active-sessions-modal.js
// module id = 532
// module chunks = 0